import { render } from "./FactoryRegion.vue?vue&type=template&id=6d24501b"
import script from "./FactoryRegion.vue?vue&type=script&lang=js"
export * from "./FactoryRegion.vue?vue&type=script&lang=js"

import exportComponent from "/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__